"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var ToolBarComboBoxFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarComboBoxFilter");
var ButtonDoSync_1 = require("../../../../../../../../shared/components/buttons/ButtonDoSync");
var BrandPayProvidersByTrustZonesList = /** @class */ (function (_super) {
    __extends(BrandPayProvidersByTrustZonesList, _super);
    function BrandPayProvidersByTrustZonesList(props) {
        return _super.call(this, props) || this;
    }
    BrandPayProvidersByTrustZonesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
            trust_zone_id: this.props.trust_zones[0].key,
            trust_zone_title: this.props.trust_zones[0].value,
            is_all_trust_zones: false
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, _this.state.is_all_trust_zones, _this.state.trust_zone_id);
        });
    };
    BrandPayProvidersByTrustZonesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandPayProvidersByTrustZonesList.prototype.doLockedAction = function (Key, Title, isLocked) {
        var _this = this;
        this.props.data.DoSetIsLocked(Key, isLocked, function () {
            if (isLocked) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            _this.props.data.LoadData(_this.props.rootRecord.key, _this.state.is_all_trust_zones, _this.state.trust_zone_id);
        });
    };
    BrandPayProvidersByTrustZonesList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 30; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u2116 ",
                i,
                " "));
        }
        return _ret;
    };
    BrandPayProvidersByTrustZonesList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    BrandPayProvidersByTrustZonesList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.DoSetOrderNumber(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, _this.state.is_all_trust_zones, _this.state.trust_zone_id, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0434\u043B\u044F \u0437\u043E\u043D\u044B \u0434\u043E\u0432\u0435\u0440\u0438\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    BrandPayProvidersByTrustZonesList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Провайдер',
                dataIndex: this.props.data.dk_pay_provider_config_title,
                key: this.props.data.dk_pay_provider_config_title,
                width: 150,
            }, {
                title: 'Зона доверия',
                dataIndex: this.props.data.dk_trust_zone_title,
                key: this.props.data.dk_trust_zone_title,
                width: 150,
            }, {
                title: 'Номер п/п',
                dataIndex: this.props.data.dk_order_number,
                key: this.props.data.dk_order_number,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440 ",
                            record.order_number,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 130,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать", text: "Нет" }, lockedTexts: { menu: "Заблокировать", text: "Да" }, record: { key: record.key, title: record.pay_provider_config_title, locked: record.is_locked }, onLockClick: _this.doLockedAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditDataClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }]);
    };
    BrandPayProvidersByTrustZonesList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandPayProvidersByTrustZonesList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 ",
                React.createElement("b", null,
                    "[",
                    record.pay_provider_config_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandPayProvidersByTrustZonesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key, this.state.is_all_trust_zones, this.state.trust_zone_id);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick(this.state.trust_zone_id);
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandPayProvidersByTrustZonesList.prototype.onCurrencyFilterChanged = function (allTrustZones, ZoneId) {
        this.setState({ trust_zone_id: ZoneId, is_all_trust_zones: allTrustZones });
    };
    BrandPayProvidersByTrustZonesList.prototype.fillProvidersClick = function () {
        var _this = this;
        this.props.data.DoFillTrustZone(this.props.rootRecord.key, this.state.trust_zone_id, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, _this.state.is_all_trust_zones, _this.state.trust_zone_id);
        });
    };
    BrandPayProvidersByTrustZonesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoSync_1.default, { hint: "Импортировать провайдеров", onClick: this.fillProvidersClick.bind(this), disabled: this.state.is_all_trust_zones }),
                React.createElement(ToolBarComboBoxFilter_1.default, { allItems: this.state.is_all_trust_zones, availItems: this.props.trust_zones, captions: { checkbox: "Все зоны доверия", placeholder: "Выберите зону доверия" }, selectedItem: this.state.trust_zone_id, onFilterChanged: this.onCurrencyFilterChanged.bind(this), width: "100%", isHideAllItemsCheckBox: false })),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); }, scroll: { x: true } })));
    };
    return BrandPayProvidersByTrustZonesList;
}(React.Component));
exports.default = BrandPayProvidersByTrustZonesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/pay_providers_trust_zones/BrandPayProvidersByTrustZonesList.tsx
// module id = 1809
// module chunks = 0